import type { CSSProperties } from 'react';
import { useMemo } from 'react';
import clsx from 'clsx';
import styles from './MediaContainer.module.css';

type MediaContainerProps = {
  children: React.ReactNode;
  height: number;
  isCompact?: boolean;
  width: number;
};

export const MediaContainer = ({
  children,
  height,
  isCompact = false,
  width,
}: MediaContainerProps) => {
  const style = useMemo(
    () =>
      ({
        '--media-height': `${height}px`,
        '--media-width': `${width}px`,
      }) as CSSProperties,
    [height, width]
  );

  return (
    <div
      className={clsx(styles.container, { [styles.compact]: isCompact })}
      style={style}
    >
      {children}
    </div>
  );
};
